import React from "react";
import "./NotFoundPage.scss";
import useShowLoader from "../common/loading-widgets/useShowLoader.js";
import useTranslationApp from "./useTranslationApp.js";

export default function NotFoundPage() {
  // RENDER
  const {t, loading: tLoading} = useTranslationApp(useShowLoader);

  useShowLoader(tLoading, "NotFoundPage");

  return (
    <div className="NotFoundPage">
      {t('app:notfound_content')}
    </div>
  );
}
